/* eslint-disable */
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './OreePriceIndicesWidget.module.css';

const OREE_DAM_URL = 'https://www.oree.com.ua/index.php/control/results_mo/DAM';

/**
 * OREE (Market Operator) — link to official DAM results on oree.com.ua (no iframe).
 * @see https://www.oree.com.ua/
 */
export default function OreePriceIndicesWidget() {
  const { t } = useTranslation();

  return (
    <section className={styles.widgetSection} aria-labelledby="oree-widget-title">
      <div className={styles.widgetCard}>
        <div className={styles.widgetHeader}>
          <h2 id="oree-widget-title" className={styles.widgetTitle}>
            {t('b2bOreePriceIndicesTitle')}
          </h2>
          <a
            href={OREE_DAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.widgetLink}
            title={t('b2bOreePriceIndicesOpen')}
          >
            {t('b2bOreePriceIndicesOpen')}
          </a>
        </div>
      </div>
    </section>
  );
}
